<script setup lang="ts">
import OperationOfficeAutoComplete from "@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue"
import getOperationOffice from "@/types/responses/getOperationOffice"
import { Ref, ref, computed } from 'vue'
import i18n from '@/lang/i18n';

const emits = defineEmits(['search'])
const props = defineProps<{
    loading: boolean
  }>()

const hide: Ref<boolean> = ref(false)
const operationOffice: Ref<getOperationOffice | undefined> = ref()
const operationOfficeType = "App\\Models\\OperationOffice"
const accountName: Ref<string | null> = ref(null)
const status: Ref<string | null> = ref('only-active')

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchBtnLabel = computed(() => {
  return props.loading ?
    i18n.global.t('pages.common.button.loading'):
    i18n.global.t('pages.common.button.exec')
})

function handleClickSearch() {
  const params = {
    type_class: operationOfficeType,
    officeable_id: operationOffice.value?.id ?? null,
    account_name: accountName.value,
    status: status.value
  }
  emits('search', params)
}

function clearForm() {
  operationOffice.value = undefined
  accountName.value = null
  status.value = 'only-active'
}

function toggleSidebar() {
  hide.value = !hide.value
}
</script>
<template>
  <div :class="searchAreaClass">
    <h4 class="d-flex justify-content-between mt-0">
      {{ title }}
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fit=""
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        sandboxuid="0"
        @click="toggleSidebar"
      >
        <template v-if="hide">
          <path d="M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z" fill-rule="evenodd" sandboxuid="0"></path>
        </template>
        <template v-if="!hide">
          <path d="M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z" sandboxuid="0" />
        </template>
      </svg>
    </h4>
    <div :class="`strpied-tabled-with-hover ${hide ? 'd-none' : '' }`">
      <div class="conditions v-theme--light">
        <OperationOfficeAutoComplete
          v-model="operationOffice"
        />
        <v-text-field
          class="pt-2"
          :label="i18n.global.t('pages.allowAccessOffice.accountName')"
          v-model="accountName"
          outlined
          hide-details="auto"
        />
        <div class="p-1">
          <div style="font-size: 13px; color: gray; font-weight: bold;">
            {{ i18n.global.t('pages.common.filter.status.title') }}
          </div>
          <v-radio-group
            v-model="status"
            hide-details="auto"
            class="radio-group-row"
          >
            <v-radio
              hide-details="auto"
              value="only-active"
              :label="i18n.global.t('pages.common.filter.status.onlyActive')"
              color="blue"
            ></v-radio>
            <v-radio
              hide-details="auto"
              value="all"
              :label="i18n.global.t('pages.common.filter.status.all')"
              color="blue"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="col-md-3">
          <svg
            version="1.2"
            style="overflow: visible; width: 299px; height: 1px; opacity: 1; mix-blend-mode: normal; rotate(0deg);"
          >
            <defs>
              <path id="path-1650848226989195" d="M1126 703 C1126 703 1425 703 1425 703"></path>
            </defs>
            <g transform="translate(-1126, -703)">
              <path style="stroke: rgb(194, 186, 186); stroke-width: 1; stroke-linecap: butt; stroke-linejoin: miter; fill: none;" d="M1126 703 C1126 703 1425 703 1425 703"></path>
            </g>
          </svg>
        </div>
        <div class="d-flex search-buttons" >
          <v-btn
            class="ma-2 exec-btn"
            @click="handleClickSearch"
            :style="{
              backgroundColor : props.loading ? '#B3B8BB' : ''
            }"
          >
            {{ searchBtnLabel }}
          </v-btn>
          <v-btn
            class="ma-2 reset-btn"
            @click="clearForm"
          >
            リセット
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
